import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";

import {
  saveCarecellVideoSuccess,
  saveCarecellVideoFailure,
  updateCarecellVideoSuccess,
  updateCarecellVideoFailure,
  deleteCarecellVideoSuccess,
  deleteCarecellVideoFailure,
  readCarecellVideoSuccess,
  readCarecellVideoFailure,
} from "./carecellVideoActions";

import {
  saveCarecellVideo,
  updateCarecellVideo,
  deleteCarecellVideo,
  readCarecellVideos,
} from "./carecellVideoAPI";

// ✅ SAVE
function* saveCarecellVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(saveCarecellVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(saveCarecellVideoSuccess(res.data));
      toast.success(res.message || "CareCell Video Saved!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(saveCarecellVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ UPDATE
function* updateCarecellVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(updateCarecellVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(updateCarecellVideoSuccess(res.data));
      toast.success(res.message || "CareCell Video Updated!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(updateCarecellVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ DELETE
function* deleteCarecellVideoSaga(action) {
  try {
    const res = yield call(deleteCarecellVideo, action.payload);

    if (res?.type === 1) {
      yield put(deleteCarecellVideoSuccess(action.payload));
      toast.success(res.message || "CareCell Video Deleted!");
      if (action.callback) action.callback({ type: 1 });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(deleteCarecellVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ READ
function* readCarecellVideosSaga(action) {
  try {
    const res = yield call(readCarecellVideos, action.payload);

    if (res?.type === 1) {
      yield put(readCarecellVideoSuccess(res.data));
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(readCarecellVideoFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// WATCHER
export default function* carecellVideoWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_CARECELL_VIDEO_REQUEST, saveCarecellVideoSaga);
  yield takeLatest(actionTypes.UPDATE_CARECELL_VIDEO_REQUEST, updateCarecellVideoSaga);
  yield takeLatest(actionTypes.DELETE_CARECELL_VIDEO_REQUEST, deleteCarecellVideoSaga);
  yield takeLatest(actionTypes.READ_CARECELL_VIDEO_REQUEST, readCarecellVideosSaga);
}
